/**
 * Created by pony.ma@nirvana-info on .
 */
import utils from '@/assets/utils'

export function mUaEvent (el, binding) {
  // v-m-ua-event(['category', 'action', 'label'])
  let value = []
  value[0] = binding[0] || 'notSet'
  value[1] = binding[1] || 'notSet'
  value[2] = binding[2] || 'notSet'
  el.addEventListener('click', () => {
    utils.uaEvent(value[0], value[1], value[2])
  })
}



// WEBPACK FOOTER //
// ./src/assets/directives.js